let config = {
  dev: {
    rooturl: "http://localhost:8080",
    version: "0.3.8",
    client_id: "client.id.1",
    client_secret: "client.secret.1",
  },
  prod: {
    rooturl: "", //"https://jolly-elbakyan.52-66-115-33.plesk.page",
    version: "0.3.7",
    client_id: "client.id.1",
    client_secret: "client.secret.1",
  },
};

export const isDevMode = false;

export const APP_MODE = isDevMode ? "dev" : "prod";

export const API_ROOT_URL = `${config[APP_MODE].rooturl}/api`;
export const SOCKET_URL = config[APP_MODE].rooturl;
export const APP_VERSION = config[APP_MODE].version;
export const CLIENT_ID = config[APP_MODE].client_id;
export const CLIENT_SECRET = config[APP_MODE].client_secret;
export const ALLOWED_ROLES = [
  "Parent Organisation Super Admin",
  "Parent Organisation Admin",
];
export const WEBSOCKET_URL = config[APP_MODE].rooturl;
